import DEVICE_CONFIG from '@shared/config';
import PropTypes from 'prop-types';

const DeviceSelector = ({ devices, onChange }) => (
  <div className="device-grid">
    {Object.entries(DEVICE_CONFIG).map(([key, config]) => {
      const selected = devices.includes(key);
      return (
        <button
          type="button"
          key={key}
          className={`device-option ${selected ? 'selected' : ''}`}
          onClick={() => onChange([key])}
        >
          <i className={`bi ${config.icon}`} />
          <span>{config.label}</span>
          <small>
            {config.width} × {config.height}
          </small>
        </button>
      );
    })}
  </div>
);

DeviceSelector.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};
export default DeviceSelector;
